package io.github.dautovicharis.charts.internal.common.model

data class ChartDataItem(
    val label: String,
    val item: ChartData,
)
